import { defineStore } from 'pinia';
import type { PaymentBodyType } from '~/types';

export const useAddPaymentStore = defineStore('add-payment', {
  state: () => ({
    OptId: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    WalletPayer: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    WalletReceiver: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    FirstNamePayer: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    LastNamePayer: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    EmailPayer: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    Amount: {
      value: undefined as number | undefined,
      isValid: undefined as boolean | undefined
    },
    Commission: {
      value: undefined as number | undefined,
      isValid: undefined as boolean | undefined
    },
    Comment: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    SuccessUrl: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    CancelUrl: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    ErrorUrl: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    NotifUrl: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    Style: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    Password: {
      value: undefined as string | undefined,
      isValid: undefined as boolean | undefined
    },
    paymentFormId: '' as string | undefined,
    currentStep: 0 as number,
    sections: [
      'wallets.paymentMethods.paymentForms.details.formDetails',
      'wallets.paymentMethods.paymentForms.urls.urls',
      ''
    ] as Array<string>,
    openAddModal: false as boolean,
    Language: undefined as string | undefined
  }),
  getters: {
    getPaymentBody(): PaymentBodyType {
      return {
        Amount: this.Amount.value ? Number(this.Amount.value).toFixed(2).toString() : undefined,
        CancelUrl: this.CancelUrl.value,
        Comment: this.Comment.value,
        Commission: this.Commission.value
          ? Number(this.Commission.value).toFixed(2).toString()
          : undefined,
        EmailPayer: this.EmailPayer.value,
        ErrorUrl: this.ErrorUrl.value,
        FirstNamePayer: this.FirstNamePayer.value,
        Language: this.Language,
        LastNamePayer: this.LastNamePayer.value,
        NotifUrl: this.NotifUrl.value,
        OptId: this.OptId.value,
        Password: this.Password.value,
        Style: this.Style.value,
        SuccessUrl: this.SuccessUrl.value,
        WalletPayer: this.WalletPayer.value,
        WalletReceiver: this.WalletReceiver.value
      };
    }
  },
  actions: {
    init(initialState: PaymentBodyType): void {
      this.Amount = {
        value: initialState.Amount
          ? typeof initialState.Amount === 'string'
            ? parseFloat(initialState.Amount)
            : initialState.Amount
          : undefined,
        isValid: true
      };
      this.Commission = {
        value: initialState.Commission
          ? typeof initialState.Commission === 'string'
            ? parseFloat(initialState.Commission)
            : initialState.Commission
          : undefined,
        isValid: true
      };
      this.CancelUrl = { value: initialState.CancelUrl || undefined, isValid: true };
      this.Comment = { value: initialState.Comment || undefined, isValid: true };
      this.EmailPayer = { value: initialState.EmailPayer || undefined, isValid: true };
      this.ErrorUrl = { value: initialState.ErrorUrl || undefined, isValid: true };
      this.FirstNamePayer = { value: initialState.FirstNamePayer || undefined, isValid: true };
      this.LastNamePayer = { value: initialState.LastNamePayer || undefined, isValid: true };
      this.NotifUrl = { value: initialState.NotifUrl || undefined, isValid: true };
      this.OptId = { value: initialState.OptId?.toString() || undefined, isValid: true };
      this.Style = { value: initialState.Style || undefined, isValid: true };
      this.SuccessUrl = { value: initialState.SuccessUrl || undefined, isValid: true };
      this.WalletPayer = { value: initialState.WalletPayer || undefined, isValid: true };
      this.WalletReceiver = { value: initialState.WalletReceiver || undefined, isValid: true };
      (this.Language = initialState.Language), (this.paymentFormId = undefined);
      this.openAddModal = false;
    },
    handleDisableSubmit() {
      return this.currentStep === 1 && !this.Password.value;
    },
    handleSetPaymentFormId(id: string) {
      this.paymentFormId = id;
    },
    resetInputs() {
      this.OptId.value = undefined;
      this.WalletPayer.value = undefined;
      this.FirstNamePayer.value = undefined;
      this.LastNamePayer.value = undefined;
      this.EmailPayer.value = undefined;
      this.Amount.value = undefined;
      this.Commission.value = undefined;
      this.Comment.value = undefined;
      this.SuccessUrl.value = undefined;
      this.CancelUrl.value = undefined;
      this.ErrorUrl.value = undefined;
      this.NotifUrl.value = undefined;
      this.Style.value = undefined;
      this.Password.value = undefined;
    }
  }
});
